
<template>
    <div>
    {{ checkModal }}
    <component v-if="isAttach" :is="isAttach" :type="attachType" @remove ="attachCloseModal" @attachFile ="attachFile"></component>
    <b-modal v-model="modalShow" ref="my-modal" hide-footer title="Загрузка видео">
    <div class="row">

      <div class="attech_tab_items">
                  <b-form-file v-if="upPhoto == null"
              :multiple = "Boolean(false)"
              accept="video/*"
      v-model="file1"
      @change="uploadFile"
      :state="Boolean(file1)"
      :placeholder="'Нажмите или перетащите видео'"
      drop-placeholder="Отпустите файл..."
    ></b-form-file>
    <div  v-else class="modal_attfile_prew">
      <div  class="att_controls">
                    <button class="icon delete" @click="upPhoto = null;file1 = null" title="Удалить">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#3a494e"/></svg>
                    </button>
                  </div>
             <div class="pg-player">
          <vue-plyr :options="plyrOptions">
            <video :src="upPhoto" playsinline class="addvideo-prew"></video>
          </vue-plyr>
        </div>
    </div>
                
              </div>

              <div class="col-12" v-if="0 > 1">
                <div class="form-label mt-3 text-left photoUpload">
                  <div class="dropdown" @click.privent="attachMedia('video')">
                    <video v-if="upPhoto" :src="upPhoto" muted controls  loop></video>
    <svg v-if="!upPhoto" id="photoUploadLenta" data-bs-toggle="dropdown" aria-expanded="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 12C22 13.31 21.75 14.57 21.28 15.72C20.63 15.27 19.84 15 19 15C18.06 15 17.19 15.33 16.5 15.88C15.58 16.61 15 17.74 15 19C15 19.75 15.21 20.46 15.58 21.06C15.62 21.13 15.67 21.2 15.73 21.27C14.58 21.74 13.32 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.38 12.0001V10.6101C9.38 8.89008 10.6 8.18007 12.09 9.04007L13.29 9.73007L14.49 10.4201C15.98 11.2801 15.98 12.6901 14.49 13.5501L13.29 14.2401L12.09 14.9301C10.6 15.7901 9.38 15.0901 9.38 13.3601V12.0001Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23 19C23 19.75 22.79 20.46 22.42 21.06C22.21 21.42 21.94 21.74 21.63 22C20.93 22.63 20.01 23 19 23C17.54 23 16.27 22.22 15.58 21.06C15.21 20.46 15 19.75 15 19C15 17.74 15.58 16.61 16.5 15.88C17.19 15.33 18.06 15 19 15C21.21 15 23 16.79 23 19Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.49 18.98H17.51" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 17.52V20.51" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      </div>           
    </div>
              </div>

              <div class="col-12 mb-2 mt-2" v-if="kinder_groups.length > 0">
    <select name="kinder_group" id="kinder_group" placeholder="Выберите группу" tabindex="-1" class="selectized" style="display: none;">
  <option value="0" selected="selected">Без группы</option></select>
  <v-selectize v-model="kinder_group" :options="kinder_groups" key-by="id" label="name"/>
      </div>

              <div class="col-12 mb-3" v-if="options.length > 0">
    <select name="group" id="select-cats" placeholder="Выберите группу" tabindex="-1" class="selectized" style="display: none;">
  <option value="0" selected="selected">Без группы</option></select>
  <v-selectize v-model="selected" :options="options" key-by="id" label="name"/>
      </div>
              <div class="col-12 mt-2">
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="pdesc" placeholder="Введите описание.."></textarea>
        </div>
        
    </div>
    <button class="btn btn-primary btn-block ml-auto mt-3" @click.prevent="createVideo" type="submit">Создать</button>

	
</b-modal>
    
    </div> 
        </template>
        
        <script>
         import Attach from '../media/Attach.vue';
         import VSelectize from '@isneezy/vue-selectize'
        import { BModal } from 'bootstrap-vue'
        import axios from 'axios';
        export default {
            components: { BModal, Attach, VSelectize },
           name: 'Addvideo',
           props: ['profile', 'platform', 'kinder_groups'],
            data(){
            return {
              plyrOptions: { controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'] },
              file1: null,
              selected: {id: '0', name: 'Без группы(в общую ленту)'},
              kinder_group: {id: '0', name: 'Выберите группу'},
              options: [],
                modalShow: true,
                pdesc: null,
                upPhoto: null,
                isAttach: null,
                attachType: 'photo'
            }
           },
           mounted(){
            if (this.platform) {
              this.getKinderGroups()
            }
           },
           methods: {
            uploadFile(event){
              this.$bvToast.toast('Загружаем видео..', { title: 'Система', variant: 'warning', visible: true });  
              this.uploadImage(event, 'upload')
            },
            uploadImage(event, type = 'lenta') {
           const files = event.target.files
          if (!files || files.length === 0){
            this.$bvToast.toast('Вы не выбрали видео.', { title: 'Ошибка', variant: 'danger', visible: true });
              return this.file1 = null;
          } 
          if (files.length > 1){
            this.$bvToast.toast('Максимально 1 видео.', { title: 'Ошибка', variant: 'danger', visible: true });
            return this.file1 = null;
          } 
  
    const URL = '/api/file.upload'; 
    let data = new FormData();
  files.forEach(file => {
    data.append('files[]', file);
  });
    axios.post(
      URL, 
      data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
    ).then(
      response => {
        this.$bvToast.toast('Видео загружено.', { title: 'Система', variant: 'success', visible: true });
          this.upPhoto = response.data;
      }).catch( error => {
    this.$bvToast.toast('Не удалось загрузить видео', { title: 'Ошибка', variant: 'danger', visible: true })
  })
    },
            getKinderGroups() {
            if(this.platform.type == 'babygum' && (this.profile.role == 31 || this.profile.role == 32)){
                axios.post('/api/shorts.get.lents').then( res => {
                this.options = res.data
              }).catch( error => {
              })
            }
         
     },
            createVideo(){
            if(this.upPhoto == null || typeof(this.upPhoto) == "undefined"){ 
             return this.$bvToast.toast('Вы не загрузили видео', {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
            }
                axios.post('/api/video.create', {'pdesc': this.pdesc, 'video': this.upPhoto, 'lenta_id': this.selected.id, 'kinder_group': this.kinder_group}).then( res => {
                    this.modalShow = false
                this.$router.push({ name: 'shorts.view', params: { 'id': res.data.id }})
            }).catch( error => {
                 this.$bvToast.toast(error.data.message, {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
            })
            },
            attachMedia(type){
        this.attachType = type
        this.isAttach = 'Attach'
      },
      attachCloseModal(status) {
        this.isAttach = status
      },
      attachFile(files, type, name, ftype){
        this.upPhoto = files
        this.isAttach = null
      }
           },
           emits: ['remove'],
           computed: {
        checkModal() {
            if(!this.modalShow){
                this.$emit('remove', null)
            }
           
          return 
        }
      },
       beforeDestroy() {
    if (this.upPhoto) {
      this.upPhoto = null
      this.file1 = null
    }
  }
        }
        </script>
        
        <style scoped>
          .modal_attfile_prew{
      width: 100%;
    height: 100%;
    display: block;
    position: relative;
}
          .att_controls { position: absolute; top:6px; right:6px; display:flex; gap:6px; z-index:5; }
.att_controls .icon { background: rgba(255,255,255,0.9); border-radius:6px; border: none; padding:4px; display:flex; align-items:center; justify-content:center; cursor: pointer; }
.att_controls .icon svg { display:block; }
        .addvideo-prew{
          width: auto;
    max-height: 300px;
    margin: 0 auto;
    display: block;
        }
        </style>
        